module.exports = __webpack_public_path__ + "static/animationSectionImage-6e565806e5460025c0671dd9aae33c5f.png";